function getYPositionElement(element) {
  let curtop = 0;
  if (element.offsetParent) {
    do {
      curtop += element.offsetTop;
    } while ((element = element.offsetParent));
    return curtop;
  }
}

/*
 * For helping find family on nested array
 * data = Array list
 * key = key for find data
 * value = value for find data
 * childKey = nested key
 * parent = initial parent, should be an array
 */
function findFamilyOnNestedArray(data, key, value, childKey, parent) {
  return data.reduce((x, xx) => {
    if (x && x.length) {
      return x;
    }
    if (xx[key] === value) {
      const newParent = [...parent];
      newParent.push(xx);
      return newParent;
    }
    if (xx[childKey] && xx[childKey].length) {
      const newParent = [...parent];
      newParent.push(xx);
      return findFamilyOnNestedArray(xx[childKey], key, value, childKey, newParent);
    }
  }, []);
}

export { getYPositionElement, findFamilyOnNestedArray };
